/**
 * sheets.js — folder-wide sheet ordering shared by the viewer arrows, the
 * folder sheet list and the Plans panel so every surface walks a folder in
 * the SAME order. Natural filename sort (A-2 before A-10) matches how
 * estimators name drawing sets.
 */
import { isPreviewable, isPdf, isTiff } from "./theme";

export function naturalByName(a, b) {
  return String(a.name || "").localeCompare(String(b.name || ""), undefined, { numeric: true, sensitivity: "base" });
}

/**
 * Flat, ordered sheet list for one folder (folderId null = the Plans root,
 * which behaves as its own pseudo-folder so the arrows work there too).
 * Only previewable drawings count as sheets. PDFs use the server-cached
 * page count (`d.pages`); images are a single sheet; a PDF whose count is
 * not cached yet optimistically shows page 1 and refines once prepared.
 */
export function buildFolderSheets(drawings, doc, folderId, category = "plans") {
  const inFolder = (drawings || [])
    .filter((d) => (d.folder_id || null) === (folderId || null) && (d.category || "plans") === category)
    .filter((d) => isPreviewable(d))
    .sort(naturalByName);
  const out = [];
  for (const d of inFolder) {
    const pages = (isPdf(d) || isTiff(d)) ? Math.max(1, d.pages || 1) : 1;
    for (let pg = 1; pg <= pages; pg++) {
      const key = `${d.drawing_id}:${pg}`;
      const ps = (doc?.pages || {})[key] || {};
      const pageName = ps.name || `Page ${pg}`;
      const custom = ps.name && ps.name !== `Page ${pg}`;
      out.push({
        key,
        drawing: d,
        page: pg,
        name: pageName,
        label: pages > 1 ? `${d.name} · ${pageName}` : (custom ? `${d.name} · ${pageName}` : d.name),
      });
    }
  }
  return out;
}
